import { render, staticRenderFns } from "./RiskAssessmentStdDoc.vue?vue&type=template&id=fed7079c&scoped=true&"
import script from "./RiskAssessmentStdDoc.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentStdDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7079c",
  null
  
)

export default component.exports